<template>
  <svg class="stroke-current w-8 h-8 mr-1 md:mr-3" viewBox="0 0 28.36 48.24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linecap="round" stroke-linejoin="round"><rect height="47.24" rx="4.43" width="27.36" x=".5" y=".5"/><path d="m.5 16.13h27.36"/><path d="m4 6.74v5.85"/><path d="m4 19.66v9.68"/></g></svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
